import { render, staticRenderFns } from "./ArchiveOperationDialog.vue?vue&type=template&id=2e56615c&scoped=true"
import script from "./ArchiveOperationDialog.vue?vue&type=script&lang=ts"
export * from "./ArchiveOperationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56615c",
  null
  
)

export default component.exports